import React, { useContext, useEffect } from 'react';
import Subscriptions from '../subscriptions/Subscriptions';
import SubscriptionForm from '../subscriptions/SubscriptionForm';
import SubscriptionsFilter from '../subscriptions/SubscriptionsFilter';
import AuthContext from '../../context/auth/authContext';

const SubscriptionsPage = () => {
  const authContext = useContext(AuthContext);

  const { user } = authContext;

  useEffect(() => {
    authContext.loadUser();
    //eslint-disable-next-line
  }, []);

  if (user && ['admin'].indexOf(user.role) !== -1) {
    return (
      <div className='grid-2'>
        <div>
          <SubscriptionForm />
        </div>
        <div>
          <SubscriptionsFilter />
          <Subscriptions />
        </div>
      </div>
    );
  } else {
    return <div>{/* <h1>Not Authorized</h1> */}</div>;
  }
};

export default SubscriptionsPage;
